// This file was auto-generated by Fern from our API Definition.
export const PrimitiveTypeV1 = {
    Integer: "INTEGER",
    /**
     * Within the range -2^53 to 2^53 */
    Long: "LONG",
    Uint: "UINT",
    Uint64: "UINT_64",
    Float: "FLOAT",
    Double: "DOUBLE",
    Boolean: "BOOLEAN",
    String: "STRING",
    Date: "DATE",
    DateTime: "DATE_TIME",
    Uuid: "UUID",
    Base64: "BASE_64",
    BigInteger: "BIG_INTEGER",
};
